const SPEECH_SETTINGS_KEY = 'memomizer_speech_settings';

export const isSpeechSupported = () =>
  typeof window !== 'undefined' && !!window.speechSynthesis;

export const getSpeechSettings = () => {
  try {
    const stored = localStorage.getItem(SPEECH_SETTINGS_KEY);
    const parsed = stored ? JSON.parse(stored) : {};
    return { rate: parsed.rate ?? 1, accent: parsed.accent ?? 'en-US' };
  } catch {
    return { rate: 1, accent: 'en-US' };
  }
};

export const saveSpeechSettings = (settings) => {
  localStorage.setItem(SPEECH_SETTINGS_KEY, JSON.stringify(settings));
};

export const speak = (text) => {
  if (!isSpeechSupported()) return;
  const { rate, accent } = getSpeechSettings();
  speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.rate = rate ?? 1;
  const voice = speechSynthesis.getVoices().find(v => v.lang === accent);
  if (voice) utterance.voice = voice;
  utterance.lang = accent ?? 'en-US';
  speechSynthesis.speak(utterance);
};
